import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=7bdc0233&scoped=true&"
import script from "./PriceBox.vue?vue&type=script&lang=js&"
export * from "./PriceBox.vue?vue&type=script&lang=js&"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=7bdc0233&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc0233",
  null
  
)

export default component.exports